<template>
    <FormModal :model="model" :init="init" modal-id="insurance" :beforeSaving="beforeSaving" :onSetIsEditMode="onSetIsEditMode" @save="$emit('save', $event)" @destroy="$emit('destroy', $event)" item-id="id" @shown="shown" :is-enabled-view-mode="false">
<!--
        <template>
            <div :key="key" class="d-flex">
                <ItemBadges :model="model" class="mb-1" />
            </div>
        </template>
-->

        <template v-slot:form="{ error: error }">
            <b-alert show variant="warning">
                「登記 OOOOOは必須です。」のエラーメッセージが表示される場合、<a href="/me" target="_blank">マイページ</a>の「登記情報」を設定してください。
            </b-alert>

            <div v-for="value in error">
                <input-error :errors="value" />
            </div>

            <InsuranceTable
                ref="table"
                :mode="mode"
                :key="mode"
                />

            <div
                v-if="model.id"
                class="text-right mt-4"
                >
                Tuskey保険番号：{{ model.id }}
                <br>
                作成日時：{{ model.created_at | BaseDatetimeFormatter }}
                <br>
                編集猶予：{{ model.expired_at_to_edit | BaseDatetimeFormatter }}
                <br>
                <span
                    v-if="model.status !== 'draft'"
                    class="text-danger"
                    >
                    ※ 現在の状態は編集できません
                </span>
            </div>
        </template>
    </FormModal>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import InputError from '@/components/InputError.vue'
import GridPage from '@/components/GridPage.vue'
import AddressContent from '@/components/AddressContent.vue'
import LogTable from '@/components/LogTable.vue'
import InsuranceTable from '@/components/InsuranceTable.vue'

export default {
    components: {
        GridPage,
        FormModal,
        ItemBadges,
        AddressContent,
        LogTable,
        InsuranceTable,
        InputError,
    },
    emits: [
        'save',
        'destroy',
    ],
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return null
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            key: 0,
            address_from_id: null,
            address_to_id: null,
            address_importer_id: null,
            prefixes: [ 'from_', 'to_', 'importer_', ],

            order_query: '',
            order_type: 'word',
            data_orders: [],
            data_orders_selected: {},

            data_shipping: {},

            mode: '',
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'auth_level',
            'auth_profile',
            'trans',
            'insurance_default',
        ]),
    },
    mounted() {
    },
    destroyed() {
    },
    methods: {
        async beforeSaving (model) {
            const h = this.$createElement
            const messageVNode = h('div', { class: [''] }, [
                h('p', { class: ['text-left'] }, [
                    'Invoice上の通貨及び金額と合致した情報をTuskeyに登録したことを確認いたします。',
                    '詳しくは',
                    h('a', { attrs: { href: 'https://drive.google.com/file/d/1-g1TNfe9VpDFUcm8WmUfXi9MjRgBonvl/view?usp=sharing', target: '_blank', }, }, ['こちら']),
                    '。',
                ]),
            ])
            const result = await this.$utils.modalConfirm(
                this,
                '入力内容の確認',
                messageVNode,
                {
                    okVariant: 'primary',
                    okTitle: '確認しました',
                    cancelTitle: 'キャンセル',
                }
            )
            if (!result) {
                return false
            }

            let data = {}

            switch (this.mode) {
                case 'update':
                case 'create':
                    this.$utils.set(data, {
                        items: this.$refs.table.getData(),
                    })
                    break
            }

            return Object.assign(model, data)
        },
        onSetIsEditMode (model) {
            if (this.model.is_edit_mode === false) {
                this.mode = 'read'
            } else {
                this.mode = this.model.id ? 'update' : 'create'
            }

            setTimeout(() => {
console.log(this.mode)
if (this.mode === 'create') {
                this.$refs.table.loadData([ {}, ])
                this.$refs.table.loadPartialData([ this.insurance_default, ])
} else {
                this.$refs.table.loadData([ model ])
}
            }, 300)
        },
        shown () {
            this.onSetIsEditMode(this.model)
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
.shipping-address-th {
    width:0.1%;
    white-space: nowrap;
}
</style>

